<template>
  <div class="bpi">
    <div class="form-page">
      <div class="cashalo-div">
        <img src="../assets/cashalo.svg" alt="">
      </div>
    </div>

    <div class="bpi">
      <img class="bpi-logo" src="../assets/bpi.png" alt="">

      <div class="bpi-form">
        <div v-if="payment" class="payment">
          <h4>Input Payment Details</h4>
          <p>Make sure all information is correct to ensure repayment is processed.</p>
          <form class="ui form">
            <div class="field amount">
              <input type="tel"
                v-model="amount"
                maxlength="8"
                @keypress="noSCharWD"
                @focus="resetamount"
                @keydown="isNumberAmount" placeholder="Amount"
                @blur="validateAmount">
              <label>{{ amounttxt }}</label>
            </div>

            <div class="field acc">
              <div id="acclist" class="ui compact selection fluid dropdown">
                <i class="dropdown icon"></i>
                <div class="default text">Select Source Account</div>
                <div class="menu">
                  <div v-for="(item, index) in acclist" class="item" @click="getValue(item)">
                    {{ maskaccount(item.properties.account_details) }}
                  </div>
                </div>
              </div>
              <label>{{ acctxt }}</label>
            </div>

            <div class="submit-btn">
              <a v-on:click.prevent="submit"
                class="ui button bpi"
                id="next"
                :class="{disabled: !checkSubmit(), bpi: checkSubmit()}">
                NEXT
              </a>
              <a @click="cancel" class="cancel bpi">CANCEL</a>
            </div>
          </form>
        </div>

        <div v-if="summary" class="summary">
          <h4>Payment Summary</h4>
          <p>Make sure all information is correct to ensure repayment is processed.</p>
          <div class="items">
            <label class="title">Amount to be paid</label>
            <p>{{ amount }}</p>
            <label class="title">Account Source</label>
            <p>{{ this.account_details }}</p>
            <!-- <label class="title">Mobile Number <span>(BPI App Registered)</span></label>
            <p>{{ mobile }}</p> -->
            <label class="title">Additional Fee</label>
            <p>20.00</p>
          </div>
          <div class="total">
            <div class="totaltxt">Total</div>
            <div class="amount">{{ this.total }}</div>
          </div>
          <div class="submit-btn">
            <a @click="directDebit" class="ui button bpi" >
              ACCEPT
            </a>
            <a @click="backtopayment" class="cancel bpi">BACK</a>
          </div>
        </div>

        <div v-if="otp" class="otp">
          <h4>Payment OTP</h4>
          <p>To proceed with the transaction we will send an OTP code to
            <br>{{ maskMobile(otp_mobile_number) }} to verify this transaction</p>

            <div class="otpbox">
              <form class="ui form">
                <div class="field otp" id="passForm">
                  <input v-model="otp1" type="tel" maxlength="1" @keyup="onkeydown" @keypress="onkeypress">
                  <input v-model="otp2" type="tel" maxlength="1" @keyup="onkeydown" @keypress="onkeypress">
                  <input v-model="otp3" type="tel" maxlength="1" @keyup="onkeydown" @keypress="onkeypress">
                  <input v-model="otp4" type="tel" maxlength="1" @keyup="onkeydown" @keypress="onkeypress">
                  <input v-model="otp5" type="tel" maxlength="1" @keyup="onkeydown" @keypress="onkeypress">
                  <input v-model="otp6" type="tel" maxlength="1" @keyup="onkeydown" @keypress="onkeypress">
                </div>
                <div class="label-otp">
                  <label v-if="!errorotp">Input the OTP sent to your Mobile Number</label>
                  <label class="invalid" v-if="errorotp">{{ errortxt }}</label>
                </div>
              </form>
              <div class="submit-btn">
                <a v-if="sendotp" v-on:click.prevent="sendOTP"
                  class="ui button bpi"
                  id="next"
                  :class="{disabled: !checkOTP(), bpi: checkOTP()}">
                  VERIFY
                </a>

                <a v-if="resend" v-on:click.prevent="resendOTP"
                  class="ui button bpi"
                  id="next"
                  :class="{disabled: !checkOTP(), bpi: checkOTP()}">
                  Resend
                </a>

                <a v-if="loaderotp" class="ui button bpi">
                  <div class="ui active inline loader"></div>
                </a>
                <a @click="cancel" class="cancel bpi">CANCEL</a>
              </div>
            </div>
        </div>

        <div id="cancel" class="ui small modal">
          <h4>Are you sure you want to cancel transaction?</h4>

          <div class="actions">
            <a class="ui button" @click="backtohome">Yes</a>
            <a class="ui cancel button" @click="closeonly">No</a>
          </div>
        </div>

        <div id="insufficient" class="ui small modal">
          <h4>{{ error }}</h4>

          <div class="actions">
            <a class="ui cancel button" @click="reload">Cancel</a>
          </div>
        </div>

        <div id="backtoRPF" class="ui small modal">
          <h4>{{ error }}</h4>

          <div class="actions">
            <a class="ui cancel button" @click="backtohome">OK</a>
          </div>
        </div>

        <div id="error500" class="ui small modal">
          <h4>Internal server error. Please try again.</h4>

          <div class="actions">
            <a class="ui cancel button" @click="backtohome">OK</a>
          </div>
        </div>

        <div v-if="success" class="success">
          <h4>Payment Success!</h4>
          <p>The amount of {{ total }} has been debited <br>
            from {{ account_details }}, payment is now being processed
          </p>

          <div class="submit-btn">
            <a @click="backtohome" class="ui button bpi" >
              OK
            </a>
          </div>
        </div>

        <div v-if="loader" class="loader bpi">
          <h4>Loading Please wait</h4>
          <div class="ui active centered inline massive loader"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const axios = require('axios');
const { accamount, accountsurl, direct_debit, payments, validateloan } = settings
import settings from './config/settings.json';

  export default {
    name: 'bpi',
    data() {
      return {
        acctxt: 'Choose an Account to be Debited',
        acctype: '',
        amount: '',
        account: '',
        amounttxt: 'Enter Amount to be Paid',
        payment: false,
        summary: false,
        otp: false,
        success: false,
        loader: true,
        prompt: true,
        loan: '',
        sendotp: true,
        acId: this.$route.query.linked_account_token_id,
        account_details: '',
        amountValid: false,
        customerId: '',
        acc: '',
        resend: false,
        total: '',
        otp1: '',
        otp2: '',
        otp3: '',
        otp4: '',
        otp5: '',
        otp6: '',
        error: '',
        errorotp: false,
        loaderotp: false,
        errortxt: '',
        referenceId: '',
        properties: '',
        id: '',
        mobile: '',
        twenty: 20,
        otp_mobile_number: '',
        direct_debit_id: '',
        acclist: [{
          properties:
            {
              account_details: ''
            }
          }
        ],
      }
    },
    methods: {
      backtohome() {
        $('.ui.modal').modal('hide');
        this.$router.push('/')
      },

      closeonly() {
        $('.ui.modal').modal('hide');
      },

      reload() {
        $('.ui.modal').modal('hide');
        location.reload()
      },

      backtopayment() {
        this.loader = true
        this.getaccounts()
        this.summary = false
      },

      noSCharWD(evt) {
        if (event.keyCode === 46) { return true }

        if(!((event.keyCode >= 65) && (event.keyCode <= 90) || (event.keyCode >= 97) && (event.keyCode <= 122) || (event.keyCode >= 48) && (event.keyCode <= 57))){
          event.returnValue = false; return;
        }
      },

      onkeypress(evt) {
        if(!((evt.keyCode >= 65) && (evt.keyCode <= 90) || (evt.keyCode >= 97) && (evt.keyCode <= 122) || (evt.keyCode >= 48) && (evt.keyCode <= 57))){
           evt.returnValue = false;
           return;
        }

        if ((evt.keyCode > 31 && (evt.keyCode < 48 || evt.keyCode > 57)) && evt.keyCode !== 46 ||
        evt.keyCode == 186 ||
        evt.keyCode == 188 ||
        evt.keyCode == 122 || evt.keyCode == 16) {
          evt.returnValue = false;
        }
      },

      onkeydown(evt) {

        if ((evt.keyCode > 31 && (evt.keyCode < 48 || evt.keyCode > 57)) && evt.keyCode !== 46 ||
        evt.keyCode == 186 ||
        evt.keyCode == 188 ||
        evt.keyCode == 122){
          evt.returnValue = false;
        } else {
          evt.returnValue = true;
        }

        var inputs = $("#passForm input");
        inputs.each(function( i, item ) {
          $(item).keyup(function( e ) {
          if( e.keyCode === 8 || e.keyCode === 'BACKSPACE'){
          if( i === 0){ return }
       			inputs[i-1].focus();
          }
          else {
           if ($(this).val().length == $(this).attr('maxlength') && inputs[i + 1]) {
              if (inputs[i + 1]) {
                inputs[i + 1].focus();
              }
            }
          }
         });
        });
      },

      checkOTP() {
        if (!this.otp1) { return false }
        if (!this.otp2) { return false }
        if (!this.otp3) { return false }
        if (!this.otp4) { return false }
        if (!this.otp5) { return false }
        if (!this.otp6) { return false }

        return true
      },

      cancel () {
        $('#cancel').modal({closable : false,}).modal('show')
      },

      submit() {
        this.loader = true
        this.payment = false
        this.getPaymentMethod()
      },

      validateacc() {
        if (this.account_details != null) {
          $('.field.acc').removeClass('invalid').addClass('valid')
        } else {
          $('.field.acc').removeClass('valid').addClass('invalid')
        }
      },

      getValue(item) {
        this.account_details = item.properties.account_details
        this.id = item.id
      },

      getNewAmount() {
        let amount = this.amount
        amount = amount.replace(/,/g, ""); // remove commas
        amount = parseFloat(amount).toFixed(2)
        this.total = Number(amount) + Number(this.twenty)
        var n = this.total
        this.fixTotal()
      },

      fixTotal() {
        var n = this.total
        this.total = parseFloat(n).toFixed(2)
        this.addCommaTotal()
      },

      addCommaTotal() {
        var n = this.total
        this.total = n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },

      async getamount() {
        var apiPath = `${accamount}` + this.acId
        const headers = {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }

        await axios.get(apiPath, { headers })
        .then( response => {
          this.amountValid = true
          $('.field.amount').addClass('valid')
          this.amount = response.data.amount
          this.mobile = response.data.mobileNumber
          this.loan = response.data.loanId
          this.customerId = response.data.customerId

          this.fixAmount()
          this.getaccounts()
        })
        .catch( err => {
          $('#error500').modal({closable : false,}).modal('show')
        })
      },

      async getaccounts() {
        var apiPath = `${accountsurl}` + this.acId + '/accounts'
        const headers = {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }

        await axios.get(apiPath, { headers })
        .then( response => {
          this.loader = false
          this.payment = true
          this.acclist = response.data
          this.initializeDropdown()
        })
        .catch( err => {
          $('#error500').modal({closable : false,}).modal('show')
        })
      },

      async getPaymentMethod() {
        var apiPath = `${payments}`

        const params = {
          customerId: this.customerId,
          referenceId: this.loan,
          properties: {
            id: this.id
          }
        }

        const headers = {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }

        await axios.post(apiPath, params, { headers })
        .then( response => {
          this.id = response.data.id
          this.loader = false
          this.getNewAmount()
          this.summary = true
        })
        .catch( err => {
          $('#error500').modal({closable : false,}).modal('show')
        })
      },

      resettotal() {
        var total = this.total
        total = total.replace(/,/g, ""); // remove commas
        total = parseFloat(total)
        this.total = total
      },

      // async validateloan() {
      //   this.loader = true
      //   this.summary = false
      //   const amount = this.amount
      //
      //   if (amount.indexOf(',') != -1 ){
      //     this.resetamount()
      //   }
      //
      //   var apiPath = `${validateloan}`
      //   const params = {
      //     loanId: this.loan,
      //     mobile: this.mobile
      //   }
      //
      //   const headers = {
      //     'Accept': 'application/json',
      //     'Content-Type': 'application/json',
      //   }
      //
      //   await axios.post(apiPath, params, { headers })
      //   .then( response => {
      //     if (response.data.errorCode == 1001) {
      //       this.error = response.data.msg
      //       $('#insufficient').modal({closable : false,}).modal('show')
      //     } else if (response.data.errorCode == 0) {
      //       this.directDebit()
      //     } else {
      //       this.error = response.data.msg
      //       $('#insufficient').modal({closable : false,}).modal('show')
      //     }
      //   })
      //   .catch( err => {
      //     $('#error500').modal({closable : false,}).modal('show')
      //   })
      // },

      async directDebit() {
        const amount = this.amount
        if (amount.indexOf(',') != -1 ){
          this.resetamount()
        }

        this.resettotal()
        this.summary = false
        this.loader = true

        var apiPath = `${direct_debit}`
        const headers = {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }

        const params = {
          referenceId: this.loan,
          paymentMethodId: this.id,
          amount: this.amount
        }
        await axios.post(apiPath, params, { headers })
        .then( response => {
          this.loader = false

          if (response.data.status == "PENDING") {
            this.otp_mobile_number = response.data.otp_mobile_number
            this.direct_debit_id = response.data.id
            this.otp = true
          } else if (response.data.error.error_code == "INSUFFICIENT_BALANCE") {
            this.error = response.data.error.message
            $('#backtoRPF').modal({closable : false,}).modal('show')
          } else if (response.data.error.error_code == "DUPLICATE_ERROR") {
            this.error = response.data.error.message
            $('#backtoRPF').modal({closable : false,}).modal('show')
          } else if (response.data.error.error_code == "INVALID_PAYMENT_METHOD_ERROR") {
            this.error = 'Sorry, Bank account is expired. Please try another payment method.'
            $('#backtoRPF').modal({closable : false,}).modal('show')
          } else if (response.data.error.error_code == "CHANNEL_UNAVAILABLE") {
            this.error = 'Channel unavailable. Please try again later.'
            $('#backtoRPF').modal({closable : false,}).modal('show')
          } else {
            this.error = response.data.error.message
            $('#backtoRPF').modal({closable : false,}).modal('show')
          }
        })
        .catch( err => {
          $('#error500').modal({closable : false,}).modal('show')
        })
      },

      async resendOTP () {
        this.loaderotp = true
        this.errorotp = false
        this.resend = false
        this.sendotp = false
        this.loader = false
        this.otp1 = ''
        this.otp2 = ''
        this.otp3 = ''
        this.otp4 = ''
        this.otp5 = ''
        this.otp6 = ''
        $('.field.otp').removeClass('invalid')

        var apiPath = `${direct_debit}` + this.direct_debit_id + '/resend_otp/'
        const headers = {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }

        await axios.post(apiPath, { headers })
        .then( response => {
          this.loaderotp = false
          this.sendotp = true
        })
        .catch( err => {
          $('#error500').modal({closable : false,}).modal('show')
        })
      },

      async sendOTP() {
        // this.otp = false
        this.loaderotp = true
        this.sendotp = false
        this.errorotp = false
        $('.field.otp').removeClass('invalid')

        var apiPath = `${direct_debit}` + this.direct_debit_id + '/validate_otp/'
        const headers = {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }

        const params = {
          otpCode: this.otp1 + this.otp2 + this.otp3 + this.otp4 + this.otp5  + this.otp6
        }

        await axios.post(apiPath, params, { headers })
        .then( response => {
          this.loader = false

          if (response.data.status == "COMPLETED") {
            this.otp = false
            this.fixTotal()
            this.success = true
          } else if (response.data.error.error_code == "EXPIRED_OTP_ERROR") {
            $('.field.otp').addClass('invalid')
            this.errorotp = true
            this.loaderotp = false
            this.sendotp = false
            this.resend = true
            this.errortxt = response.data.error.message
          } else if (response.data.error.error_code == "INVALID_OTP_ERROR") {
            $('.field.otp').addClass('invalid')
            this.errorotp = true
            this.loaderotp = false
            this.sendotp = true
            this.resend = false
            this.errortxt = response.data.error.message
          } else if (response.data.error.error_code == "MAX_OTP_ATTEMPTS_ERROR") {
            $('.field.otp').addClass('invalid')
            this.errorotp = true
            this.loaderotp = false
            this.sendotp = false
            this.resend = true
            this.errortxt = response.data.error.message
          } else {
            $('.field.otp').addClass('invalid')
            this.errorotp = true
            this.loaderotp = false
            this.sendotp = false
            this.resend = true
            this.errortxt = response.data.error.message
          }
        })
        .catch( err => {
          $('#error500').modal({closable : false,}).modal('show')
        })
      },

      initializeDropdown() {
        const self = this
        window.setTimeout(()=>{
          $('#acclist').dropdown({
            on: 'click',
            allowReselection: true,
            onChange: (value, text) => {
              const str = value
              value = str.replace(/\d(?=\d{4})/g, "*");
              self.account_details = value

              this.validateacc()
            },
          });
        },500)
      },

      checkSubmit() {
        if (!this.amountValid) {
          return false
        }

        if (!this.account_details) {
          return false
        }
        return true
      },

      resetamount() {
        if (this.amountValid) {
          this.amount = this.amount ? this.amount : 0;
            var amount = this.amount
            amount = amount.replace(/,/g, ""); // remove commas
            amount = parseFloat(amount)
            this.amount = amount

            if (isNaN(this.amount)) this.amount = '';
        } else {
          return false
        }
      },

      validateAmount() {
        var regex = /^[1-9]\d*(((,\d{3}){1})?(\.\d{0,2})?)$/;

        if(this.amount != null){
          if(this.amountValid = regex.test(this.amount) && this.amount != '' && this.amount) {
            if (this.amount >= 50) {
              $('.field.amount').removeClass('invalid').addClass('valid')
              this.fixAmount()
              this.amounttxt = 'Enter Amount to be Paid'
            } else {
              this.amountValid = false
              $('.field.amount').addClass('invalid').removeClass('valid')
              this.amounttxt = 'Amount to pay must not be lower than PHP 50.00'
            }
          } else {
            if(this.amount) {
              //invalid mobile
              this.amountValid = false
              $('.field.amount').addClass('invalid').removeClass('valid')
              this.amounttxt = 'Error! Invalid Amount'
            } else {
              //no input
              this.amountValid = false
              $('.field.amount').removeClass('invalid').removeClass('valid')
              this.amounttxt = 'The minimum payment is PHP 50.00'
            }
          }
        } else {
          //no input
          $('.field.amount').addClass('invalid').removeClass('valid')
          this.amounttxt = 'Error! Invalid Amount'
        }
      },

      isNumberAmount(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57))
        && charCode !== 46 && charCode != 190 && charCode != 110
        && (charCode > 105 || charCode < 96)) {
          evt.preventDefault();
        } else if (charCode === 46) {
          evt.preventDefault();
        } else {
          return true;
        }
      },

      fixAmount() {
        var n = this.amount
        this.amount = parseFloat(n).toFixed(2)
        this.addComma()
      },

      addComma() {
        var n = this.amount
        this.amount = n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },

      maskaccount(value) {
        var str = value
        return value = str.replace(/\d(?=\d{4})/g, "*");
      },

      maskMobile(value) {
        var str = value
        return value = str.toString().replace(/^.{10}/g, "**** *** ");
      }
    },
    mounted() {
      this.getamount()
      // console.log(this.$route.query.linked_account_token_id);
    }
  }
</script>
